import { render } from "./PieStat.vue?vue&type=template&id=712f83bf&scoped=true"
import script from "./PieStat.vue?vue&type=script&lang=js"
export * from "./PieStat.vue?vue&type=script&lang=js"

import "./PieStat.vue?vue&type=style&index=0&id=712f83bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712f83bf"]])

export default __exports__